import React from "react"
import {
  useAccordion,
  useAccordionItem,
} from "contexts/components/AccordionContext"
import { FaPlus, FaMinus } from "react-icons/fa"

import "./accordion.module.scss"

interface AccordionToggleProps {
  children: string
  ariaControls: string
}

export const AccordionToggle = ({
  children,
  ariaControls,
}: AccordionToggleProps) => {
  const { handlePanelClick, isFAQ, activePanel } = useAccordion()
  const { id } = useAccordionItem()

  const isButtonActive =
    activePanel === id ? "fr-accordion__btn-toggle--active" : ""

  const faqName = isFAQ
    ? {
        itemProp: "name",
      }
    : {}

  return (
    <dt className={`fr-accordion__btn-toggle-container`}>
      <button
        className={`fr-accordion__btn-toggle ${isButtonActive}`}
        onClick={() => handlePanelClick(id)}
        type="button"
        aria-controls={ariaControls}
        aria-expanded={id === activePanel ? "true" : "false"}
      >
        <h3 {...faqName}>{children}</h3>
        {activePanel === id ? (
          <span className="fr-accordion__btn-toggle-icon-container">
            <FaMinus size={30} className="fr-accordion__btn-toggle-icon" />
          </span>
        ) : (
          <span className="fr-accordion__btn-toggle-icon-container">
            <FaPlus size={30} className="fr-accordion__btn-toggle-icon" />
          </span>
        )}
      </button>
    </dt>
  )
}
